import { render, staticRenderFns } from "./ShowEvent.vue?vue&type=template&id=4229b2aa&"
import script from "./ShowEvent.vue?vue&type=script&lang=js&"
export * from "./ShowEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports